var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"products",attrs:{"title":"Produkter"}},[_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":_vm.createButtonClick},slot:"tools"}),_c('new-table-view',{attrs:{"columns":[
		{
			label: 'Navn',
			name: 'label'
		},
		{
			label: 'Moms',
			name: 'vat'
		},
		{
			label: 'Type',
			name: 'type',
			translation: {
				default: 	'Tjenester',
				product: 	'Produkter',
				loan: 		'Produkter (udlån)',
				free: 		'Produkter (leveres)'
			}
		},
		{
			label: '',
			name: 'delete',
			align: 'right',
			template: {
				name: 'button',
				label: 'Slet'
			}
		}
	],"items":_vm.items},on:{"itemClick":_vm.itemClick,"delete":_vm.itemDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }